"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.COMMIT_DATE = exports.COMMIT_AUTHOR = void 0;
const COMMIT_AUTHOR = exports.COMMIT_AUTHOR = 'commit_author';
const COMMIT_DATE = exports.COMMIT_DATE = 'commit_date';